export default "__VITE_ASSET__BNzvS5EY__"